import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
import { ref, onMounted } from 'vue';
import useMainStore from '@views/main/main.store';
import { typewriterEffect } from '@utils/window-helpers';
export default /*@__PURE__*/_defineComponent({
  __name: 'AssessInfo',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const mainStore = useMainStore();
    const info = ref({});
    const showText = ref('');
    onMounted(() => {
      try {
        info.value = props.content;
        if (props.item.openAnimate) {
          typewriterEffect(info.value.tips, currentText => {
            showText.value += currentText;
          }, () => {
            mainStore.loadNextMsg(props.item);
          });
        } else {
          showText.value = info.value.tips;
        }
      } catch (error) {
        console.log(error);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "assess-info whitespace-pre-wrap leading-[18px]",
        innerHTML: showText.value
      }, null, 8, _hoisted_1);
    };
  }
});